<template>
  <wo-page v-if="currentUser">
    <wo-region>
      <wo-layout>
        <wo-title tag-name="h1" v-t="'userAccount.title'"></wo-title>
         <wo-grid>
            <wo-column width-lg="8">
              <user-props :value="currentUser" />
              <wo-spacer />
            </wo-column>
            <wo-column width-lg="4">
              <user-contact-props :value="currentUser" />
            </wo-column>
         </wo-grid>
      </wo-layout>
    </wo-region>
  </wo-page>
</template>

<script>

import { mapState } from 'vuex'

import UserProps from '@/components/identity/UserProps'
import UserContactProps from '@/components/identity/UserContactProps'

export default {
  name: 'UserAccountView',
  components: { UserProps, UserContactProps },
  computed: mapState({
    currentUser: state => state.identity.currentUser
  })
}
</script>
